import { RouteObject } from "react-router-dom";
import HomePage from "@/pages/home/page";
import MissionPage from "@/pages/mission/page";
import ProjectsPage from "@/pages/projects/page";
import ProjectDetailPage from "@/pages/projects/detail/page";
import StoriesPage from "@/pages/stories/page";
import StoryDetailPage from "@/pages/stories/detail/page";
import VolunteerPage from "@/pages/volunteer/page";
import DonatePage from "@/pages/donate/page";
import ContactPage from "@/pages/contact/page";
import AdminLoginPage from "@/pages/admin/page";
import AdminDashboardPage from "@/pages/admin/dashboard/page";
import AdminProjectsPage from "@/pages/admin/projects/page";
import AdminMessagesPage from "@/pages/admin/messages/page";
import AdminVolunteersPage from "@/pages/admin/volunteers/page";
import AdminUsersPage from "@/pages/admin/users/page";
import AdminContentPage from "@/pages/admin/content/page";
import AdminPashtoCmsPage from "@/pages/admin/content/pashto/page";
import AdminDariCmsPage from "@/pages/admin/content/dari/page";
import AdminPhotosPage from "@/pages/admin/photos/page";
import AdminStoriesPage from "@/pages/admin/stories/page";
import ProtectedRoute from "@/components/feature/ProtectedRoute";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/mission", element: <MissionPage /> },
  { path: "/projects", element: <ProjectsPage /> },
  { path: "/projects/:id", element: <ProjectDetailPage /> },
  { path: "/stories", element: <StoriesPage /> },
  { path: "/stories/:slug", element: <StoryDetailPage /> },
  { path: "/volunteer", element: <VolunteerPage /> },
  { path: "/donate", element: <DonatePage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/admin", element: <AdminLoginPage /> },
  {
    path: "/admin/dashboard",
    element: <ProtectedRoute><AdminDashboardPage /></ProtectedRoute>,
  },
  {
    path: "/admin/projects",
    element: <ProtectedRoute><AdminProjectsPage /></ProtectedRoute>,
  },
  {
    path: "/admin/messages",
    element: <ProtectedRoute><AdminMessagesPage /></ProtectedRoute>,
  },
  {
    path: "/admin/volunteers",
    element: <ProtectedRoute><AdminVolunteersPage /></ProtectedRoute>,
  },
  {
    path: "/admin/users",
    element: <ProtectedRoute requireAdmin><AdminUsersPage /></ProtectedRoute>,
  },
  {
    path: "/admin/content",
    element: <ProtectedRoute><AdminContentPage /></ProtectedRoute>,
  },
  {
    path: "/admin/content/pashto",
    element: <ProtectedRoute><AdminPashtoCmsPage /></ProtectedRoute>,
  },
  {
    path: "/admin/content/dari",
    element: <ProtectedRoute><AdminDariCmsPage /></ProtectedRoute>,
  },
  {
    path: "/admin/photos",
    element: <ProtectedRoute><AdminPhotosPage /></ProtectedRoute>,
  },
  {
    path: "/admin/stories",
    element: <ProtectedRoute><AdminStoriesPage /></ProtectedRoute>,
  },
  { path: "*", element: <NotFound /> },
];

export default routes;
